<template>
  <div id="InspectionReportView">
    <div id="container-center">
      <div class="labelTitle lable">点検報告書参照</div>
      <div class="condition-area">
        <b-button class="backbutton is-primary" @click="back">戻る</b-button>
      </div>

      <div class="result-area">
        <iframe
          ref="preview"
          style="width: 100vw; height: 100vh"
          :src="url"
          type="application/pdf"
        />
      </div>

      <div class="result-area">
        <b-button class="backbutton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { role } from "@/components/mock/base/const.js";

export default {
  name: "InspectionReportView",

  methods: {
    back: function () {
      this.$router.push({
        name: this.$route.params["fromPageName"],
        params: {
          preSearchConditions: this.$route.params["preSearchConditions"],
        },
      });

      return;
    },

    createUrl: function () {
      const inspectionReport = this.$route.params["inspectionReport"];

      let url = window.location.origin + "/webapi/v1/getSmsInspectionReportFile?";
      url += "appointmentCode=" + inspectionReport.appointmentCode;
      url += "&inspectionId=" + inspectionReport.inspectionCode;
      url += "&printType=" + inspectionReport.kind;
      url += "&sendType=" + inspectionReport.sendType;
      url += "&destinationId=" + inspectionReport.sendType;
      url += "#toolbar=0";

      this.url = url;

      return;
    },
  },

  data() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    return {
      url: null,
      userInfo,
    };
  },

  filters: {},

  components: {},

  mounted: function () {
    if (this.userInfo.roleId != role.role_hospital) {
      this.$router.go(-1);
    }

    this.createUrl();

    return;
  },
};
</script>

<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}

#item-contens table tr th {
  width: 70px;
}

#item-contens table tr td button {
  width: 165px;
  margin-right: 3px;
}
.button-group {
  margin-top: 2px;
}
.file-dialog {
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/InspectionReportView.vue